App.factory('ChromeExtension', [
  '$rootScope',
  'browser',
  '$window',
  'ngDialog',
  'responseHelper',
  'UserExtensionStats',
  'CHROME_EXTENSION_PMS',
  'FeatureFlag',
  '$timeout',
  function (
    $rootScope,
    browser,
    $window,
    ngDialog,
    responseHelper,
    UserExtensionStats,
    CHROME_EXTENSION_PMS,
    FeatureFlag,
    $timeout
  ) {
    let chromeExtensionModalRefreshEnabled = false
    let chromeExtensionModalEligible = false
    let reminderInterval = null
    let blockingTimeout = null
    let extensionUnreachable = false

    const REMINDER_POLL_MS = 3000
    // Long enough for one poll retry after the initial miss, short enough that a stalled
    // service worker does not read as a missing extension. Keep above REMINDER_POLL_MS.
    const MAX_BLOCKING_MS = 5000

    FeatureFlag.$find("chrome_extension_modal_refresh").$then((ff) => {
      chromeExtensionModalRefreshEnabled = !!ff["chrome_extension_modal_refresh"]
    })
    FeatureFlag.$find("chrome_extension_modal_eligible").$then((ff) => {
      chromeExtensionModalEligible = !!ff['chrome_extension_modal_eligible']
    })

    // Allow internal users to toggle Chrome extension modal by adding a
    // `cer` ("Chrome extension required") query param to the URL and
    // persisting preferences to localStorage.
    const searchParams = $rootScope.location_ref.search()
    if (searchParams && searchParams['cer'] === 'true') {
      $window.localStorage.removeItem('chrome-extension-required')
    } else if (searchParams && searchParams['cer'] === 'false') {
      $window.localStorage.setItem('chrome-extension-required', 'false')
    }

    const chromeExtensionModal = () => document.querySelector('nh-chrome-extension-modal')

    // Only path that closes the modal — it renders without a close control.
    const dismissReminder = () => {
      if (reminderInterval) {
        clearInterval(reminderInterval)
        reminderInterval = null
      }
      if (blockingTimeout) {
        $timeout.cancel(blockingTimeout)
        blockingTimeout = null
      }
      const modal = chromeExtensionModal()
      if (modal) {
        modal.setAttribute('isopen', false)
      }
    }

    // Clear both — a lone latch reset leaves a stale deadline to fire a false alarm, and vice versa.
    const noteExtensionReachable = () => {
      extensionUnreachable = false
      dismissReminder()
    }

    reminderPopup = (internal_scope, chromeExtensionIds, allowClose) => {
      if (chromeExtensionModalRefreshEnabled && browser.chrome) {
        // Must precede every early return below, or re-entry orphans the running poller.
        if (reminderInterval) {
          clearInterval(reminderInterval)
          reminderInterval = null
        }

        // Re-entry must not reopen the modal mid-episode; a confirmed probe clears this.
        if (extensionUnreachable) {
          return
        }

        const chromeExtensionPms = Object.values(CHROME_EXTENSION_PMS).find(
          (pms) => pms.ids === this.retrieveChromeExtensionIds()
        )
        if (chromeExtensionPms && chromeExtensionPms.url) {
          const modal = chromeExtensionModal()
          if (!modal) {
            return
          }

          modal.setAttribute('isopen', true)
          modal.setAttribute('url', chromeExtensionPms.url)

          // Own timer, not a miss count or poll-tick check: a probe can fail by never calling
          // back, and re-entry recreates the poller. $timeout — the toast needs a digest.
          if (blockingTimeout === null) {
            blockingTimeout = $timeout(() => {
              extensionUnreachable = true
              dismissReminder()
              responseHelper.toasterResponse(
                'We could not reach the NexHealth Synchronizer extension.',
                'warning',
                'Synchronizer unreachable',
                0
              )
            }, MAX_BLOCKING_MS)
          }

          reminderInterval = setInterval(() => {
            checkChromeExtensionVersion(chromeExtensionIds, (response) => {
              if (!response) {
                return
              }
              noteExtensionReachable()
              sendChromeExtensionUsageStats(response.version)
            })
          }, REMINDER_POLL_MS)
        }
        return
      }
      opts = {
        template: '/app/views/modal/chrome-extension-reminder.html',
        className: 'ne__modal ne__modal--chrome-extension-reminder',
        scope: internal_scope,
        controller: 'chromeExtensionModalCtrl',
        showClose: allowClose,
        closeByEscape: allowClose,
        closeByDocument: allowClose
      }
      internal_scope.reminderDialog = ngDialog.open(opts)
      internal_scope.reminderDialog.closePromise.then((_data) => {
        // I believe this code could be removed, since the user is not allowed to close the extension anymore

        setRemindLater()
        // This confirms (after the user close the reminder modal), if the chrome extension was really installed
        if (!browser.chrome) {
          return sendChromeExtensionUsageStats(browser.name)
        } else {
          checkChromeExtensionVersion(chromeExtensionIds, (response) => {
            if (response) {
              responseHelper.toasterResponse('Extension enabled', 'success', 'Success')
              return sendChromeExtensionUsageStats(response.version)
            } else {
              // No chrome extension installed
              return sendChromeExtensionUsageStats('0')
            }
          })
        }
      })
    }

    shouldShowReminder = () => {
      if (!chromeExtensionModalEligible) {
        return false
      }

      if ($rootScope.embedded) {
        return false
      }

      if (chromeExtensionModalRefreshEnabled) {
        if (
          $window.localStorage.getItem('chrome-extension-required') === 'false' ||
          $rootScope.impersonationSessionId != null || $rootScope.impersonated
        ) {
          return false
        }
        return true
      }
      // It didn't work .calendar() as we do in the chrome-extension, this version is too old

      if ($rootScope.impersonationSessionId != null || $rootScope.impersonated) {
        return false
      }

      saved =
        moment(
          $window.localStorage.getItem('chrome-extension-reminder'),
          'YYYY-MM-DDTHH:mm:ss'
        ).valueOf() || 0
      now = moment(new Date()).add(-10, 'minutes').valueOf()

      reminderTimeoutPassed = saved < now

      if (reminderTimeoutPassed) setRemindLater()

      return reminderTimeoutPassed
    }

    setRemindLater = () => {
      var lastCheckReminderInString = moment(new Date()).format('YYYY-MM-DDTHH:mm:ss')
      $window.localStorage.setItem('chrome-extension-reminder', lastCheckReminderInString)
    }

    sendMessageToExtensions = (chromeExtensionIds, responseFunction) => {
      let chromeExtensionIdsCopy = [...chromeExtensionIds];

      let firstId = chromeExtensionIdsCopy.shift()

      if (firstId === undefined) {
        responseFunction(undefined)
        return
      }

      chrome.runtime.sendMessage(firstId, { url: '', type: 'Version' }, (response) => {
        if (response) {
          responseFunction(response)
        } else {
          sendMessageToExtensions(chromeExtensionIdsCopy, responseFunction)
        }
      })
    }

    checkChromeExtensionVersion = (chromeExtensionIds, responseFunction) => {
      if (chrome.runtime) {
        try {
          sendMessageToExtensions(chromeExtensionIds, responseFunction)
        } catch (err) {
          lg('error reaching chrome-extension reminder', err)
          setRemindLater()
        }
      } else {
        responseFunction(undefined)
      }
    }

    this.retrieveChromeExtensionIds = () => {
      let chromeExtensionIds = []
      // Once we have more extensions to different PMS's, we need to add those here.
      // eg for foreign_id_type: msg-denticon-DataSource-771 or msg-dentrix_enterprise-DataSource-798
      const PMSKeys = Object.keys(CHROME_EXTENSION_PMS)
      // $viewContentLoaded can fire on a redirect (e.g. app.campaign_template -> .actions)
      // before /me has populated $rootScope.locations
      const locationIncludesPMS = ($rootScope.locations || []).find(loc => PMSKeys.some(id => loc.foreign_id_type.includes(id)))

      if ($rootScope.locations && locationIncludesPMS && locationIncludesPMS.foreign_id_type) {
        if (typeof locationIncludesPMS.foreign_id_type !== 'string') return

        const PMSKey = PMSKeys.find(key => locationIncludesPMS.foreign_id_type.match(key))
        chromeExtensionIds = CHROME_EXTENSION_PMS[PMSKey].ids
      }

      // If there is not any supported chrome extension between the PMS's this user has, so no call needed
      return chromeExtensionIds
    }

    sendChromeExtensionUsageStats = (version) => {
      const resp = UserExtensionStats.$create({ extension_version: version })
      return resp.$then(() => {
        if (!resp.$response.data.code) {
          lg('error sending user stats', resp.$response.data)
        }

        return true
      })
    }

    this.checkInstallation = (internal_scope) => {
      const chromeExtensionIds = this.retrieveChromeExtensionIds()

      if (chromeExtensionIds.length && shouldShowReminder()) {
        if (browser.mobile) {
          return false
        }
        if (!browser.chrome) {
          reminderPopup(internal_scope, chromeExtensionIds, true)
          return false
        }
        checkChromeExtensionVersion(chromeExtensionIds, (response) => {
          if (!response) {
            reminderPopup(internal_scope, chromeExtensionIds, false)
            return false
          }
          noteExtensionReachable()
          lg('Extension version: ', response.version)
          setRemindLater()
          return sendChromeExtensionUsageStats(response.version)
        })
      }
    }

    return this
  }
])
